// Utils.ts
const get = (obj: any, path: string, defaultValue: any = undefined): any => {
  const keys = path.split('.');
  return keys.reduce((acc, key) => (acc && acc[key] !== undefined? acc[key] : defaultValue), obj);
};

const set = (obj: any, path: string, value: any): void => {
  const keys = path.split('.');
  const lastKey = keys.pop();

  if (!lastKey) {
    return;
  }

  const nestedObj = keys.reduce((acc, key) => {
    if (!acc[key]) {
      acc[key] = {};
    }
    return acc[key];
  }, obj);

  nestedObj[lastKey] = value;
};

const evaluateTemplate = (template: string, data: any, root: any) => {
  return template.replace(/\${(.*?)}/g, (match, p1) => root && p1.startsWith('root.')? get(root, p1.substring(5).trim()) : get(data, p1.trim()));
}

const evaluateExpression = (expr: string, context: any): any => {
  return new Function(...Object.keys(context), `return ${expr};`)(...Object.values(context));
}

const isEmpty = (data: any) => {
  // Check for undefined or null
  if (!data) {
    return true;
  }

  // Check for an empty array
  if (Array.isArray(data) && data.length === 0) {
    return true;
  }

  // Check for an object with no properties
  if (typeof data === 'object' && Object.keys(data).length === 0) {
    return true;
  }

  // For all other cases, return false
  return false;
}

const removeEmptyProperties = (obj: Record<string, any>) => {
  for (const key in obj) {
    if (obj[key] === null || obj[key] === undefined) {
      delete obj[key]; // Remove property if it's null or undefined
    }
  }
};

// Function to get the first element
const firstElement = (data: any) => {
  if (Array.isArray(data)) {
      if (data.length === 0) {
          data.push({});
      }
      return data[0];
  }
  return data;
};

const isObject = (value: any) => typeof value === 'object' && value !== null;

export { get, set, evaluateTemplate, evaluateExpression, isEmpty, isObject, removeEmptyProperties, firstElement };
